export default __webpack_public_path__ + "media/images/big-phone-db7f4146a9ab75bf258fce15b9ded0cf.png";